import React from 'react'
import Modal from '../../../components/Modal'
import DateRangeFilter from '../../../components/DateRangeFilter'
import { today } from '../utils/paymentHelpers'

export function ExportModal({
  showExportModal,
  setShowExportModal,
  exportStartDate,
  setExportStartDate,
  exportEndDate,
  setExportEndDate,
  exportSelectedEmployees,
  setExportSelectedEmployees,
  employees,
  exporting,
  handleExportSalaries
}) {
  return (
    <Modal
      isOpen={showExportModal}
      onClose={() => setShowExportModal(false)}
      title="Экспорт зарплатной ведомости"
      isBottomSheet={true}
    >
      <div className="export-modal-content">
        <div className="input-group">
          <label>Период</label>
          <DateRangeFilter
            startDate={exportStartDate}
            endDate={exportEndDate}
            onApply={(s, e) => { setExportStartDate(s); setExportEndDate(e) }}
            onReset={() => { setExportStartDate(today()); setExportEndDate(today()) }}
          />
        </div>

        <div className="input-group" style={{ marginTop: '16px' }}>
          <label>Сотрудники ({exportSelectedEmployees.length})</label>
          <div className="export-employee-list" style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid var(--border-color)', borderRadius: '8px', padding: '8px', marginTop: '4px' }}>
            <div style={{ marginBottom: '8px', paddingBottom: '8px', borderBottom: '1px solid var(--border-color)', display: 'flex', gap: '8px' }}>
              <button className="btn btn-ghost btn-sm" onClick={() => setExportSelectedEmployees(employees.filter(e => !e.is_legacy).map(e => e.id))}>Все</button>
              <button className="btn btn-ghost btn-sm" onClick={() => setExportSelectedEmployees([])}>Никого</button>
            </div>
            {employees.filter(e => !e.is_legacy).map(emp => (
              <label key={emp.id} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '4px 0', cursor: 'pointer' }}>
                <input 
                  type="checkbox" 
                  checked={exportSelectedEmployees.includes(emp.id)} 
                  onChange={(e) => {
                    if (e.target.checked) setExportSelectedEmployees([...exportSelectedEmployees, emp.id])
                    else setExportSelectedEmployees(exportSelectedEmployees.filter(id => id !== emp.id))
                  }}
                />
                <span>{emp.name}</span>
              </label>
            ))}
          </div>
        </div>

        <div className="modal-actions" style={{ marginTop: '24px' }}>
          <button 
            className="btn btn-primary" 
            style={{ width: '100%' }}
            disabled={exporting || exportSelectedEmployees.length === 0}
            onClick={handleExportSalaries}
          >
            {exporting ? 'Формирование...' : 'Скачать ведомость (Excel)'}
          </button>
        </div>
      </div>
    </Modal>
  )
}
